import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { Slider, SliderSlide } from "@ui"
import {
  ArticlePreview,
  EditorChoiceTopBorder,
  EditorChoiceBottomBorder,
} from "@features/journal"
import { BreakPoints } from "styles/styles"

export const EditorChoice = observer(function EditorChoice() {
  const {
    ResponsiveModel: { width },
    BlogModel: { editorChoice, getTemplate },
  } = useStore()

  if (!editorChoice || !editorChoice.length) {
    return null
  }

  let slidesCount = width < BreakPoints.tablet ? 1 : 2
  if (width >= BreakPoints.laptop) {
    slidesCount = Math.min(Math.floor(width / 400), 3)
  }

  return (
    <section className="bg-gray-50 relative" data-test-id="editors_choice">
      <EditorChoiceTopBorder className="h-3.5 w-full text-gray-50 absolute -top-3.5" />
      <EditorChoiceBottomBorder className="h-3.5 w-full text-gray-50 absolute -bottom-3.5" />
      <div className="container overflow-hidden px-0 pt-8 pb-6.5 tablet:pt-12 tablet:pb-10 laptop:px-20 desktop:px-22 desktop:pt-17 desktop:pb-34 desktop-l:px-20">
        <div className="flex items-center px-4 mb-5 tablet:px-6 tablet:mb-9 laptop:justify-center laptop:mb-12">
          <div className="font-serif text-2xl uppercase tracking-2 pt-[5px] tablet:text-4xl tablet:pt-0">
            {getTemplate("editorChoice.title")}
          </div>
        </div>
        {editorChoice.length > slidesCount ? (
          <Slider
            options={{
              spaceBetween: -24,
              slidesPerView: "auto",
              navigation: true,
              breakpoints: {
                600: {
                  spaceBetween: -36,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                1440: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
              },
            }}
          >
            {editorChoice.map((item) => (
              <SliderSlide
                key={item.id}
                className="w-full px-4 tablet-s:w-2/5 tablet-s:px-6 laptop:w-full laptop:px-0"
              >
                <ArticlePreview
                  article={item}
                  imageProps={{ priority: true }}
                  classes={{
                    container:
                      "tablet-s:h-[445px] laptop:h-[376px] desktop:h-[697px]",
                  }}
                />
              </SliderSlide>
            ))}
          </Slider>
        ) : (
          <div className="flex justify-center space-x-4 px-4 tablet-s:px-6 tablet:space-x-8 desktop:px-0 desktop:space-x-4">
            {editorChoice.map((item) => (
              <ArticlePreview
                article={item}
                imageProps={{ priority: true }}
                classes={{
                  container:
                    "tablet-s:w-2/5 tablet-s:h-[445px] laptop:w-1/3 laptop:h-[376px] desktop-l:h-[697px]",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
})
